<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import draggable from "vuedraggable";
import MultiSelect from "vue-multiselect";
import DatePicker from "vue2-datepicker";

//  Custom Components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import hkService from "@/helpers/APIService/hk.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { task_sheet_sequence } from "@/helpers/global.variable";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// create new task Component

export default {
  page: {
    title: "Payment Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    draggable,
    MultiSelect,
    DatePicker,
  },
  computed: {
    ...authComputed,
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  data() {
    return {
      title: "Task sheet",
      editable: true,
      isDragging: false,
      test: false,
      tabIndex: 0,
      todayDate: "",
      task: {
        title: "",
        date: moment().format("YYYY-MM-DD"),
        roomTypes: [],
        rooms: [],
        staffs: [],
        sequence: { value: "morning", text: "Morning" },
      },
      SequenceOptions: task_sheet_sequence,
      TTOptions: [
        { value: "full", text: "Full", disabled: false },
        { value: "green", text: "Half", disabled: false },
      ],
      options: [
        { value: "none", text: "None" },
        { value: "those", text: "Those" },
      ],
      totalCredit: 0.0,
      totalRooms: 0,
      totalDuration: 0,
      roomTable: {
        tableData: [],
        is_data_loading: true,
      },
      staffTable: {
        tableData: [],
        is_data_loading: true,
      },
      staff: {},
      updateStaffType: "",
      totalStaff: 0,
      onlineStaff: 0,
      offlineStaff: 0,
      submitted: false,
      isBtnLoading: false,
      taskStaffData: {},
      sheetId: "",
      temp: {},
      selectAllTask: false,
      selectAllStaff: false,
      selectAllTaskForIns: false,
      rightClick: false,
      taskId: "",
      staffOptions: [],
      selectStaffToMove: "",
      filter: { value: "none", text: "None" },
    };
  },
  validations: {
    task: {
      title: { required },
      sequence: { required },
      date: { required },
    },
  },
  methods: {
    // Method is use for add rooms
    addRooms(data) {
      if (data == "SelectAll") {
        this.task.roomTypes = [];
        this.selectAllTask = !this.selectAllTask;
        if (this.selectAllTask) {
          this.roomTable.tableData.map((data) => {
            this.task.roomTypes.push(data);
          });
        }
      } else {
        if (this.task.roomTypes.includes(data.id)) {
          this.task.roomTypes.unshift(data);
        }
      }
    },
    // Method is use to add/remove inspection required
    inspectionRequired(data) {
      if (data == "SelectAll") {
        this.selectAllTaskForIns = !this.selectAllTaskForIns;
        this.roomTable.tableData = this.roomTable.tableData.map((data) => {
          data.is_inspection_required = this.selectAllTaskForIns;
          return data;
        });
      } else {
        if (this.task.roomTypes.includes(data.id)) {
          data.is_inspection_required = false;
        }
      }
    },
    // Method is use for add staffs
    addStaffs(data) {
      if (data == "SelectAll") {
        this.task.staffs = [];
        this.selectAllStaff = !this.selectAllStaff;
        if (this.selectAllStaff) {
          this.staffTable.tableData.map((data) => {
            this.task.staffs.push(data);
          });
        }
      } else {
        if (this.task.staffs.includes(data.id)) {
          this.task.staffs.unshift(data);
        }
      }
    },
    // Method is use for show drop down
    showDropDown(id) {
      this.sheetId = id;
      this.rightClick = false;
      this.taskId = "";
    },
    // Method is use for convert duration into time
    getTimeFromMins(time) {
      let hours = Math.trunc(time / 60);
      let minutes = time % 60;
      return `${hours.toString().length !== 1 ? hours : `0${hours}`}:${
        minutes.toString().length !== 1 ? minutes : `0${minutes}`
      }:00`;
    },
    //Method is use for calc duration
    getTimes(duration) {
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
      hours = moment(duration, "HH:mm:ss").hours();
      minutes = moment(duration, "HH:mm:ss").minutes();
      seconds = moment(duration, "HH:mm:ss").seconds();
      if (hours !== 0) {
        minutes = minutes + Math.trunc(hours * 60);
      }
      if (seconds !== 0) {
        minutes = minutes + Math.trunc(seconds / 60);
      }
      return parseInt(minutes);
    },
    // Method is for create final response
    getResponse() {
      let data = {};
      data.hotel = this.hotel.id;
      data.title = this.task.title;
      data.sequence = this.task.sequence.value;
      data.sheet_date = this.task.date;
      data.total_task = 0;
      data.total_credit = 0;
      data.pending_tasks = 0;
      data.total_duration = this.totalDuration;
      data.total_staff = 0;
      let totalSelectedTask = [];
      this.task.rooms.map((item) => {
        totalSelectedTask.push(item);
      });
      let eq =
        parseInt(totalSelectedTask.length) / parseInt(this.task.staffs.length);
      let assignTask = [];
      this.task.staffs.map((staff, index) => {
        let tempArr = {
          staff_user: "",
          credit: parseFloat(0.0),
          section: [],
          tasks: 0,
          duration: 0.0,
          hkstafftask_set: [],
          staff_user_data: "",
          pending_tasks: 0,
          completed_tasks: 0,
          in_progres_tasks: 0,
        };
        if (index < this.task.staffs.length) {
          tempArr.staff_user_data = {
            id: staff.id,
            staff_id: staff.staff_id,
            name: staff.name,
            profile_picture: staff.profile_picture,
          };
          tempArr.staff_user = staff.id;
          tempArr.credit = parseFloat(0.0);
          tempArr.duration = 0;
          let minutes = 0;
          totalSelectedTask.splice(0, Math.ceil(eq)).map((item) => {
            tempArr.hkstafftask_set.push({
              staffId: staff.id,
              roomData: item,
              room: item.id,
              is_inspection_required: item.is_inspection_required,
              inspection_by: "",
              priority_order: 0,
              task_type: "full",
            });
            tempArr.credit += parseFloat(item.room_type.hk_stay_over_credit);
            minutes += moment(
              item.room_type.hk_stay_over_duration,
              "HH:mm:ss"
            ).minutes();
            tempArr.duration = minutes;
            tempArr.pending_tasks = tempArr.hkstafftask_set.length;
            tempArr.tasks = tempArr.hkstafftask_set.length;
            if (tempArr.section.length != 0 && tempArr.section !== undefined) {
              if (!tempArr.section.includes(item.section.name)) {
                tempArr.section.push(item.section.name);
              }
            }
          });
          data.total_task += parseInt(tempArr.hkstafftask_set.length);
          data.pending_tasks += parseInt(tempArr.hkstafftask_set.length);
        }
        assignTask.push(tempArr);
      });
      data.total_duration = null;
      this.task.roomTypes.map((item) => {
        data.total_duration += moment(
          item.room_type.hk_stay_over_duration,
          "HH:mm:ss"
        ).minutes();
        data.total_credit += item.room_type.hk_stay_over_credit;
      });
      data.stafftasksheet_set = assignTask;
      data.total_staff = parseInt(data.stafftasksheet_set.length);
      return data;
    },
    // Method is use for handle next tab
    nextTab() {
      if (this.tabIndex == 3) {
        let data = this.taskStaffData;
        data.stafftasksheet_set.map((item, index) => {
          if (item.hkstafftask_set.length == 0) {
            data.stafftasksheet_set.splice(index, 1);
          }
          item.hkstafftask_set.map((task, index) => {
            task.priority_order = index + 1;
            return task;
          });
          item.duration = this.getTimeFromMins(item.duration);
          return item;
        });
        data.total_duration = this.getTimeFromMins(data.total_duration);
        hkService
          .createTaskSheet(data)
          .then((response) => {
            Middleware.notification(
              "Task sheet created successfully !!",
              "success"
            );
            this.$router.push({ path: `/task-sheet` });
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
      if (this.tabIndex == 2) {
        this.tabIndex++;
        const data = this.getResponse();
        this.taskStaffData = data;
      } else if (this.tabIndex == 1) {
        this.tabIndex++;
        this.task.rooms = this.task.roomTypes;
        UserService.getStaffList()
          .then((response) => {
            this.totalStaff = response.length;
            let tempStaff = [];
            response.map((item) => {
              tempStaff.push({
                id: item.id,
                staff_id: item.staff_id,
                name:
                  item.title != null
                    ? item.title + " "
                    : "" + item.first_name + " " + item.last_name,
                profile_picture: item.profile_picture,
                role: item.role.name,
                rating: 5,
                maxDuration: 100,
                maxCredit: 100,
              });
            });
            this.staffTable.tableData = tempStaff;
            this.staffTable.is_data_loading = false;
          })
          .catch((error) => {
            errorHandler(error);
          });
      } else if (this.tabIndex == 0) {
        this.todayDate = this.task.date;
        this.totalCredit = 0.0;
        this.submitted = true;
        this.isBtnLoading = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isBtnLoading = false;
          return;
        } else {
          this.tabIndex = +1;
          this.submitted = false;
          this.isBtnLoading = false;
          UserService.getRoomList()
            .then((response) => {
              let minutes = 0;
              this.roomTable.tableData = response.map((item) => {
                this.totalCredit += parseFloat(
                  item.room_type.hk_stay_over_credit
                );
                minutes += moment(
                  item.room_type.hk_stay_over_duration,
                  "HH:mm:ss"
                ).minutes();
                this.totalDuration = minutes;
                return { ...item, is_inspection_required: false };
              });
              this.totalRooms = this.roomTable.tableData.length;
              this.roomTable.is_data_loading = false;
              this.selectDirtyRooms();
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      } else {
        this.tabIndex++;
      }
    },
    // Method is use for change status
    changeStatus() {
      const newData = this.taskStaffData.stafftasksheet_set.map((staff) => {
        staff.hkstafftask_set.map((room) => {
          if (room.status !== undefined) {
            room.task_type = room.status.value;
          }
          return room;
        });
        return staff;
      });
      this.taskStaffData.stafftasksheet_set = newData;
      this.sheetId = "";
    },
    log: function (evt) {
      const data = this.getResponse();
      this.temp = this.temp.map((item) => {
        let minutes = 0;
        let credit = 0;
        let section = [];
        item.hkstafftask_set.map((room) => {
          minutes += moment(
            room.roomData.room_type.hk_stay_over_duration,
            "HH:mm:ss"
          ).minutes();
          item.duration = minutes;
          credit += parseFloat(room.roomData.room_type.hk_stay_over_credit);
          item.credit = credit;
          if (
            item.section.length != 0 &&
            !item.section.includes(room.roomData.section.name)
          ) {
            section.push(room.roomData.section.name);
          }
          item.section = section;
          return room;
        });
        item.tasks = item.hkstafftask_set.length;
        item.pending_tasks = item.hkstafftask_set.length;
        return item;
      });
      data.stafftasksheet_set = this.temp;
      this.taskStaffData = data;
    },
    // Method is use for update some value
    changeStaffValue(data, status) {
      this.staff = data;
      this.updateStaffType = status;
    },
    // Method is use for update value of staff
    updateStaffValue() {
      this.staffTable.tableData = this.staffTable.tableData.map((item) => {
        if (item.id === this.staff.id) {
          item = this.staff;
        }
        return item;
      });
      this.staff = "";
      this.updateStaffType = "";
    },
    // Method is use for remove room
    removeRoom(roomData) {
      Swal.fire({
        title: "Are you sure ?",
        text: `You want to remove room ${roomData.roomData.room_number}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          let data = this.taskStaffData;
          data.stafftasksheet_set.map((item) => {
            if (item.staff_user === roomData.staffId) {
              item.hkstafftask_set.map((task, index) => {
                if (task.room === roomData.room) {
                  item.hkstafftask_set.splice(index, 1);
                  item.tasks = item.tasks - 1;
                  item.credit =
                    item.credit -
                    parseInt(task.roomData.room_type.hk_stay_over_credit);
                  item.pending_tasks = item.pending_tasks - 1;
                  data.total_credit =
                    data.total_credit -
                    parseInt(task.roomData.room_type.hk_stay_over_credit);
                }
                return task;
              });
              return item.hkstafftask_set;
            }
            return item;
          });
          this.taskStaffData = data;
          this.rightClick = false;
          this.taskId = "";
        }
      });
    },
    // Method is use for find other staff where we can move a task
    func(data, staff_user) {
      this.staffOptions = [];
      this.rightClick = true;
      this.taskId = data.room;
      this.taskStaffData.stafftasksheet_set.map((item) => {
        if (item.staff_user !== staff_user) {
          this.staffOptions.push({
            value: item.staff_user_data.id,
            text: item.staff_user_data.name,
          });
        }
      });
    },
    // Method is use for move task from one staff to other staff
    moveTaskOverStaff(data) {
      if (this.selectStaffToMove !== "") {
        this.taskStaffData.stafftasksheet_set.map((item) => {
          let section = [];
          if (item.staff_user === data.staffId) {
            alert();
            item.hkstafftask_set.map((task, index) => {
              if (task.room === data.room) {
                item.hkstafftask_set.splice(index, 1);
                item.pending_tasks--;
                item.tasks--;
                item.credit =
                  parseFloat(item.credit) -
                  parseFloat(data.roomData.room_type.hk_stay_over_credit);
                item.duration =
                  parseInt(item.duration) -
                  this.getTimes(data.roomData.per_room_duration);
              }
              return task;
            });
          }
          if (item.staff_user === this.selectStaffToMove.value) {
            alert();
            item.pending_tasks++;
            item.tasks++;
            item.credit =
              parseFloat(item.credit) +
              parseFloat(data.roomData.room_type.hk_stay_over_credit);
            item.duration =
              parseInt(item.duration) +
              this.getTimes(data.roomData.per_room_duration);
            const newData = { ...data, staffId: this.selectStaffToMove.value };
            item.hkstafftask_set.push(newData);
            this.rightClick = false;
            this.taskId = "";
            this.selectStaffToMove = "";
            this.staffOptions = [];
          }
          item.hkstafftask_set.map((task) => {
            if (!section.includes(task.roomData.section.name)) {
              section.push(task.roomData.section.name);
            }
          });
          item.section = section;
          return item;
        });
      }
    },
    // Method is use for generate a avatar
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
    selectDirtyRooms() {
      this.task.roomTypes = [];
      this.roomTable.tableData.map((room) => {
        if (room.hk_status == "d" && room.occupancy_status !== "ooo") {
          this.task.roomTypes.push(room);
        }
      });
    },
    copyCode(code) {
      Middleware.copyCode(code);
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="card">
      <div class="card-body">
        <b-tabs
          v-model="tabIndex"
          justified
          nav-class="nav-tabs-custom"
          content-class="p-3 text-muted"
        >
          <b-tab active>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Task</span>
            </template>
            <div class="col-md-12">
              <b-button
                variant="primary"
                class="d-block ms-auto"
                @click="nextTab"
                :class="{ disabled: isBtnLoading }"
              >
                <i
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  v-if="isBtnLoading"
                ></i>
                Create Task Sheet
              </b-button>
            </div>
            <div class="row mb-5">
              <div class="col-md-4 mb-5">
                <label for="validationCustom01">Task Title</label>
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="Task Title"
                  v-model="task.title"
                  :class="{
                    'is-invalid': submitted && $v.task.title.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.task.title.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.task.title.required">Title is required.</span>
                </div>
              </div>
              <div class="col-md-4 mb-5">
                <label for="validationCustom01">Sequence</label>
                <MultiSelect
                  v-model="task.sequence"
                  :options="SequenceOptions"
                  :show-labels="false"
                  :allow-empty="false"
                  :searchable="false"
                  placeholder="sequence"
                  track-by="value"
                  label="text"
                  :class="{
                    'is-invalid': submitted && $v.task.sequence.$error,
                  }"
                ></MultiSelect>

                <div
                  v-if="submitted && $v.task.sequence.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.task.sequence.required">
                    Sequence is required.
                  </span>
                </div>
              </div>
              <div class="col-md-4 mb-5">
                <label for="validationCustom01">Date</label>
                <date-picker
                  lang="en"
                  placeholder="MM-DD-YYYY"
                  v-model="task.date"
                  type="date"
                  value-type="format"
                  :clearable="false"
                  :disabled-date="notBeforeToday"
                  :class="{
                    'is-invalid': submitted && $v.task.date.$error,
                  }"
                ></date-picker>
                <div
                  v-if="submitted && $v.task.date.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.task.date.required">Date is required.</span>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab :disabled="task.title == '' || task.sequence == ''">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-user"></i>
              </span>
              <span class="d-none d-sm-inline-block">Select Location</span>
            </template>
            <div class="col-md-12">
              <div class="row mb-3 align-items-center">
                <div class="col-md-2">
                  <h5>
                    Total task :
                    <span class="total-number">{{ totalRooms }}</span>
                  </h5>
                </div>
                <div class="col-md-2">
                  <h5>
                    Total Credit :
                    <span class="total-number">
                      {{ parseFloat(totalCredit).toFixed(2) }}
                    </span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Duration :
                    <span class="total-number">{{ totalDuration }} min</span>
                  </h5>
                </div>
                <div class="col-md-2">
                  <h5>
                    Selected :
                    <span class="total-number">
                      {{ task.roomTypes.length }}
                    </span>
                  </h5>
                </div>
                <div class="col-md-2 ms-auto">
                  <b-button
                    variant="primary"
                    class="d-block ms-auto"
                    @click="nextTab"
                    :disabled="task.roomTypes.length == 0"
                  >
                    Next Select Staff
                  </b-button>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="table-responsive table-shadow mb-0">
                <table
                  class="table mb-0"
                  ref="my-table"
                  infinite-scroll-disabled="busy"
                  infinite-scroll-distance="10"
                >
                  <thead class="table-light">
                    <tr class="text-center">
                      <th>
                        <input
                          type="checkbox"
                          class="form-check-input font-size-18"
                          @change="addRooms('SelectAll')"
                          :checked="
                            task.roomTypes.length === roomTable.tableData.length
                          "
                        />
                      </th>
                      <th>
                        <input
                          type="checkbox"
                          class="form-check-input font-size-18"
                          @change="inspectionRequired('SelectAll')"
                          :checked="selectAllTaskForIns"
                        />
                      </th>
                      <th>Room</th>
                      <th>Room Status</th>
                      <th>Room Type</th>
                      <th>Occupancy Status</th>
                      <th>Booking</th>
                      <th>Credit</th>
                    </tr>
                  </thead>
                  <tbody v-if="roomTable.is_data_loading">
                    <tr v-for="item in 10" :key="item">
                      <td class="placeholder-glow" v-for="no in 7" :key="no">
                        <span class="placeholder w-100 placeholder-lg"></span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr
                      class="text-center"
                      v-for="(data, index) in roomTable.tableData"
                      :key="index"
                    >
                      <td>
                        <input
                          :id="index"
                          type="checkbox"
                          class="form-check-input font-size-18"
                          v-model="task.roomTypes"
                          :value="data"
                          @change="addRooms(data)"
                        />
                      </td>
                      <td>
                        <input
                          :id="index"
                          type="checkbox"
                          class="form-check-input font-size-18"
                          v-model="data.is_inspection_required"
                          :value="data.is_inspection_required"
                          @change="inspectionRequired(data)"
                        />
                      </td>
                      <td>{{ data.room_number }}</td>
                      <td>
                        <span
                          class="badge align-items-center py-1 px-2 card-badge"
                          :class="[
                            data.room_status == 'd'
                              ? 'badge-soft-danger'
                              : data.room_status == 'c'
                              ? 'badge-soft-success'
                              : data.room_status == 'p'
                              ? 'badge-soft-warning'
                              : 'badge-soft-dark',
                          ]"
                        >
                          {{
                            data.hk_status == "d"
                              ? "Dirty"
                              : data.hk_status == "c"
                              ? "Clean"
                              : data.hk_status == "p"
                              ? "Pickup"
                              : "Unknown"
                          }}
                        </span>
                      </td>
                      <td>
                        {{ data.room_type.short_name }}
                        <i
                          class="fa fa-info-circle mb-0 ms-1"
                          v-b-popover.hover.top="data.room_type.name"
                        ></i>
                      </td>
                      <td>
                        <span
                          class="badge align-items-center py-1 px-2 card-badge"
                          :class="[
                            data.occupancy_status == 'v'
                              ? 'badge-soft-primary'
                              : data.occupancy_status == 'o'
                              ? 'badge-soft-success'
                              : data.occupancy_status == 'b'
                              ? 'badge-soft-dark'
                              : data.occupancy_status == 'ooo'
                              ? 'badge-soft-warning'
                              : data.occupancy_status == 'oos'
                              ? 'badge-soft-danger'
                              : 'badge-soft-dark',
                          ]"
                        >
                          {{
                            data.occupancy_status == "ooo"
                              ? "Out Of Order"
                              : data.occupancy_status == "oos"
                              ? "Out of Service"
                              : data.occupancy_status == "b"
                              ? "Blocked"
                              : data.occupancy_status == "o"
                              ? "Occupied"
                              : "Vacant"
                          }}
                        </span>
                      </td>
                      <td>
                        {{
                          data.booking
                            ? data.booking.first_name
                              ? data.booking.first_name
                              : "-"
                            : "-"
                        }}
                        {{
                          data.booking
                            ? data.booking.last_name
                              ? data.booking.last_name
                              : ""
                            : ""
                        }}
                        <i
                          v-if="data.booking != null"
                          @click="copyCode(data.booking.reference_no)"
                          class="fa fa-info-circle mb-0 ms-1"
                          v-b-popover.hover.top="
                            'Reference No. : ' + data.booking.reference_no
                          "
                        ></i>
                      </td>
                      <td>
                        {{
                          data.booking &&
                          data.booking.check_out_date == todayDate
                            ? data.room_type.hk_check_out_credit
                            : data.room_type.hk_stay_over_credit
                        }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-if="
                      !roomTable.is_data_loading &&
                      roomTable.tableData.length == 0
                    "
                  >
                    <tr>
                      <td colspan="9" class="text-center">
                        <img
                          src="@/assets/images/empty.svg"
                          class="img-fluid"
                          alt=""
                        />
                        <p>
                          <span class="text-secondary">No Data Found</span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <b-tab :disabled="task.roomTypes.length == 0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="far fa-envelope"></i>
              </span>
              <span class="d-none d-sm-inline-block">Select Staff</span>
            </template>
            <div class="col-md-12">
              <div class="d-flex align-items-center flex-wrap mb-3">
                <div class="mx-3">
                  <h5>
                    Total Staff :
                    <span class="total-number">{{ totalStaff }}</span>
                  </h5>
                </div>
                <div class="mx-3">
                  <h5>
                    Task : <span class="total-number"> {{ totalRooms }}</span>
                  </h5>
                </div>
                <div class="mx-3">
                  <h5>Required Staff : <span class="total-number"> 5</span></h5>
                </div>
                <div class="mx-3">
                  <h5>
                    Selected :
                    <span class="total-number">{{ task.staffs.length }}</span>
                  </h5>
                </div>
                <div class="ms-auto">
                  <b-button
                    variant="primary"
                    :disabled="task.staffs.length == 0"
                    @click="nextTab"
                    >Next Confirm Detail
                  </b-button>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="table-responsive table-shadow mb-0">
                <table
                  class="table mb-0"
                  ref="my-table"
                  infinite-scroll-disabled="busy"
                  infinite-scroll-distance="10"
                >
                  <thead class="table-light">
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          class="form-check-input font-size-18"
                          @change="addStaffs('SelectAll')"
                          :checked="
                            task.staffs.length === staffTable.tableData.length
                          "
                        />
                      </th>
                      <th>Staff Name</th>
                      <th>Staff ID</th>
                      <th>Role</th>
                      <th>Ratings</th>
                      <!-- <th>Status</th> -->
                      <!-- <th>Tasks</th> -->
                      <th>Max Duration</th>
                      <th>Max Credits</th>
                    </tr>
                  </thead>
                  <tbody v-if="staffTable.is_data_loading">
                    <tr v-for="index in 10" :key="index">
                      <td class="placeholder-glow" v-for="no in 7" :key="no">
                        <span class="placeholder w-100 placeholder-lg"></span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr
                      v-for="(data, index) in staffTable.tableData"
                      :key="index"
                    >
                      <td>
                        <input
                          :id="index"
                          type="checkbox"
                          class="form-check-input font-size-18"
                          v-model="task.staffs"
                          :value="data"
                          @change="addStaffs(data)"
                        />
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <input
                            v-if="data.profile_picture != null"
                            type="image"
                            class="rounded-circle avatar-md"
                            :src="data.profile_picture"
                            alt=""
                          />
                          <div v-else class="avatar-md">
                            <div
                              class="avatar-title rounded-circle bg-secondary bg-soft"
                            >
                              {{ avatarGenerator(data.name) }}
                            </div>
                          </div>
                          <span class="ms-2">
                            {{ data.name }}
                          </span>
                        </div>
                      </td>
                      <td>{{ data.staff_id }}</td>
                      <td>
                        {{ data.role }}
                      </td>
                      <td @click="changeStaffValue(data, 'rating')">
                        <div
                          v-if="
                            staff.id == data.id && updateStaffType == 'rating'
                          "
                        >
                          <input
                            :id="index"
                            type="number"
                            autocomplete="off"
                            v-model="data.rating"
                            @blur="updateStaffValue"
                          />
                        </div>
                        <span v-else>{{ data.rating }}</span>
                      </td>
                      <!-- <td>Available</td> -->
                      <!-- <td>5</td> -->
                      <td>
                        <div
                          v-if="
                            staff.id == data.id &&
                            updateStaffType == 'maxDuration'
                          "
                        >
                          <input
                            :id="index"
                            type="number"
                            autocomplete="off"
                            v-model="data.maxDuration"
                            @blur="updateStaffValue"
                          />
                        </div>
                        <span
                          v-else
                          @click="changeStaffValue(data, 'maxDuration')"
                          >{{ data.maxDuration }} Min</span
                        >
                      </td>
                      <td>
                        <div
                          v-if="
                            staff.id == data.id &&
                            updateStaffType == 'maxCredit'
                          "
                        >
                          <input
                            :id="index"
                            type="number"
                            autocomplete="off"
                            v-model="data.maxCredit"
                            @blur="updateStaffValue"
                          />
                        </div>
                        <span
                          v-else
                          @click="changeStaffValue(data, 'maxCredit')"
                          >{{ data.maxCredit }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-if="
                      !staffTable.is_data_loading &&
                      staffTable.tableData.length == 0
                    "
                  >
                    <tr>
                      <td colspan="9" class="text-center">
                        <img
                          src="@/assets/images/empty.svg"
                          class="img-fluid"
                          alt=""
                        />
                        <p>
                          <span class="text-secondary">No Data Found</span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <b-tab :disabled="task.staffs.length == 0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-cog"></i>
              </span>
              <span class="d-none d-sm-inline-block">Confirm Details</span>
            </template>
            <div class="col-md-12">
              <div class="d-flex align-items-center flex-wrap mb-3">
                <div class="mx-3">
                  <h5>
                    Total Staff:
                    <span class="total-number">{{
                      taskStaffData.total_staff
                    }}</span>
                  </h5>
                </div>
                <div class="mx-3">
                  <h5>
                    Task:
                    <span class="total-number">
                      {{ taskStaffData.total_task }}</span
                    >
                  </h5>
                </div>
                <div class="mx-3">
                  <h5>
                    Total Credit Required:
                    <span class="total-number">
                      {{ taskStaffData.total_credit }}</span
                    >
                  </h5>
                </div>
                <div class="mx-3">
                  <h5>Required Staff:<span class="total-number"> 5</span></h5>
                </div>
                <div class="ms-auto">
                  <b-button
                    variant="primary"
                    :disabled="task.staffs.length == 0"
                    @click="nextTab"
                    >Confirm Details
                  </b-button>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div
                  class="col-md-4"
                  v-for="(item, itemIndex) in taskStaffData.stafftasksheet_set"
                  :key="itemIndex"
                >
                  <template>
                    <div class="mb-4">
                      <div class="table-responsive table-shadow">
                        <div class="bg-primary bg-gradient p-2">
                          <div
                            class="d-flex justify-content-between align-items-center"
                          >
                            <h5 class="mb-0 text-white">
                              #{{ item.staff_user_data.staff_id }}
                            </h5>
                            <div class="d-flex align-items-center">
                              <h5 class="mb-0 text-white me-2">
                                {{ item.staff_user_data.name }}
                              </h5>
                              <img
                                v-if="
                                  item.staff_user_data.profile_picture !== null
                                "
                                class="rounded-circle header-picture-img"
                                :src="item.staff_user_data.profile_picture"
                                alt="Avatar"
                              />
                              <span
                                v-else
                                class="d-flex align-items-center justify-content-center bg-soft bg-dark text-dark rounded-circle header-picture-img"
                              >
                                {{ avatarGenerator(item.staff_user_data.name) }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <table class="table mb-0">
                          <div class="d-flex">
                            <div class="bg-lightgray d-flex w-100">
                              <div style="width: 11%">Room</div>
                              <div style="width: 19%">Status</div>
                              <div style="width: 10%">TT</div>
                              <div style="width: 25%">Reservation</div>
                              <div style="width: 15%">Room</div>
                              <div style="width: 20%" class="text-center">
                                Action
                              </div>
                            </div>
                          </div>
                          <tbody>
                            <draggable
                              class="list-group p-2"
                              tag="tbody"
                              v-model="item.hkstafftask_set"
                              v-bind="dragOptions"
                              @change="log"
                            >
                              <div
                                class="list-group-item"
                                v-for="(data, index) in item.hkstafftask_set"
                                :key="index"
                              >
                                <div class="d-flex w-100">
                                  <div
                                    v-if="rightClick && data.room == taskId"
                                    style="
                                      z-index: 1;
                                      margin-top: -10px;
                                      left: 20%;
                                    "
                                    class="position-absolute w-50"
                                  >
                                    <MultiSelect
                                      v-model="selectStaffToMove"
                                      :options="staffOptions"
                                      :show-labels="false"
                                      placeholder="Staff Name"
                                      track-by="value"
                                      label="text"
                                      name="status"
                                      @close="moveTaskOverStaff(data)"
                                      class="w-100"
                                    />
                                  </div>
                                  <div
                                    @click="
                                      () => {
                                        rightClick = false;
                                        taskId = '';
                                        sheetId = '';
                                      }
                                    "
                                    class="overflow-hidden text-nowrap text-truncate cursor-move"
                                    style="width: 10%"
                                  >
                                    {{ data.roomData.room_number }}
                                  </div>
                                  <div
                                    style="width: 20%"
                                    class="text-danger me-2"
                                  >
                                    <span
                                      class="badge align-items-center py-1 px-1 card-badge"
                                      :class="[
                                        data.roomData.hk_status == 'd'
                                          ? 'badge-soft-danger'
                                          : data.roomData.hk_status == 'c'
                                          ? 'badge-soft-success'
                                          : data.roomData.hk_status == 'p'
                                          ? 'badge-soft-dark'
                                          : 'badge-soft-danger',
                                      ]"
                                    >
                                      {{
                                        data.roomData.hk_status == "d"
                                          ? "Dirty"
                                          : data.roomData.hk_status == "c"
                                          ? "Clean"
                                          : "Pickup"
                                      }}
                                    </span>
                                  </div>
                                  <div
                                    style="
                                      margin-top: -10px;
                                      z-index: 1;
                                      left: 28%;
                                    "
                                    class="position-absolute w-25"
                                    v-if="
                                      sheetId == data.room && sheetId !== ''
                                    "
                                  >
                                    <MultiSelect
                                      v-model="data.status"
                                      :options="TTOptions"
                                      placeholder="status"
                                      :show-labels="false"
                                      track-by="value"
                                      label="text"
                                      name="status"
                                      :id="index"
                                      @close="changeStatus()"
                                      class="w-100"
                                    />
                                  </div>
                                  <div :key="index" style="width: 15%">
                                    {{
                                      data.task_type == "full" ? "Full" : "Half"
                                    }}
                                  </div>
                                  <div style="width: 25%">
                                    {{
                                      data.roomData.booking !== null
                                        ? "Arrival"
                                        : "-"
                                    }}
                                  </div>
                                  <div
                                    style="width: 15%"
                                    @click="
                                      () => {
                                        rightClick = false;
                                        taskId = '';
                                      }
                                    "
                                  >
                                    {{ data.roomData.occupancy_status }}
                                  </div>
                                  <div style="width: 15%" class="text-center">
                                    <b-dropdown
                                      size="sm"
                                      variant="white"
                                      toggle-class="p-0"
                                      menu-class="dropdown-menu-end"
                                      right
                                    >
                                      <template #button-content>
                                        <i
                                          class="fas fa-ellipsis-v text-primary"
                                        ></i>
                                      </template>
                                      <b-dropdown-item
                                        href="#"
                                        @click="removeRoom(data)"
                                      >
                                        Remove Task
                                      </b-dropdown-item>
                                      <b-dropdown-item
                                        href="#"
                                        @click="func(data, item.staff_user)"
                                      >
                                        Move Task
                                      </b-dropdown-item>
                                      <b-dropdown-item
                                        href="#"
                                        @click="showDropDown(data.room)"
                                      >
                                        Change TT status
                                      </b-dropdown-item>
                                    </b-dropdown>
                                  </div>
                                </div>
                              </div>
                            </draggable>
                            <div class="d-none">
                              {{ (temp = taskStaffData.stafftasksheet_set) }}
                            </div>
                          </tbody>
                          <tfoot>
                            <div
                              class="bg-lightgray d-flex justify-content-between align-items-center"
                            >
                              <div>
                                <span
                                  >{{ task.sequence.value }} Cleaning Sequence
                                </span>
                              </div>
                              <div>
                                <span class="text-end">
                                  <span class="text-success">{{
                                    item.completed_tasks
                                  }}</span>
                                  |
                                  <span class="text-warning">{{
                                    item.in_progres_tasks
                                  }}</span>
                                  |
                                  <span class="text-danger">{{
                                    item.pending_tasks
                                  }}</span>
                                </span>
                              </div>
                            </div>
                            <div
                              class="d-flex justify-content-between align-items-center footer-color"
                            >
                              <div>
                                Rooms : {{ item.hkstafftask_set.length }}
                              </div>
                              <div>
                                Credit :
                                {{ parseFloat(item.credit).toFixed(2) }}
                              </div>
                              <!-- <div>
                                Section :
                                <span
                                  v-for="(sc, index) in item.section"
                                  :key="index"
                                >
                                  {{ sc }}
                                  <template
                                    v-if="
                                      item.section.length > 1 &&
                                      index !== item.section.length - 1
                                    "
                                    >,</template
                                  >
                                </span>
                              </div> -->
                            </div>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<style scoped>
.total-number {
  color: #000000;
}
.footer-color {
  background-color: #d7d7d7;
}

.table-shadow {
  box-shadow: 0px 0 25px 0 rgb(0 0 0 / 5%);
}

.list-group-item {
  border: 0px;
  padding: 12px 0px;
  border-bottom: 1px solid #dee2e6;
}
</style>
